export default __webpack_public_path__ + "static/media/ic_report.244594b0.svg";